import { Outlet, NavLink } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { logoutUser } from '../../redux/slices/userSlice'
import { useNavigate } from 'react-router-dom'
import { nasccLogo } from '../../assets'

export default function AdminLayout() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const user = useAppSelector((state) => state.user)

  const handleLogout = () => {
    dispatch(logoutUser())
    navigate('/admin/login')
  }

  const navItems = [
    { path: '/admin', label: 'Dashboard', exact: true, icon: '🏠' },
    {
      path: '/admin/pending-applications',
      label: 'Pending Applications',
      icon: '📋'
    },
    {
      path: '/admin/approved-applications',
      label: 'Approved Applications',
      icon: '✓'
    },
    { path: '/admin/subscribers', label: 'All Subscribers', icon: '📧' },
    { path: '/admin/documents', label: 'Documents', icon: '📄' },
    { path: '/admin/reports', label: 'Reports', icon: '📊' }
  ]

  return (
    <div className="flex h-screen bg-[#F5F5F5]">
      <nav className="w-80 bg-[#142841] text-white flex flex-col">
        <div className="p-6 bg-[#142841] border-b border-[#9298a8]/20">
          <div className="flex items-center space-x-3">
            <div className="bg-white p-3 rounded">
              <img src={nasccLogo} alt="NASCC Logo" className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-lg font-semibold">National Alliance of</h1>
              <h2 className="text-lg font-semibold">Sickle Cell Centers</h2>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto py-4">
          <ul className="space-y-1 px-3">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.exact}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors text-sm ${
                      isActive
                        ? 'bg-white text-[#142841]'
                        : 'text-gray-300 hover:bg-white/10 hover:text-white'
                    }`
                  }
                >
                  <span className="text-lg w-6 text-center">{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-4 border-t border-[#9298a8]/20">
          <div className="mb-4 text-sm">
            <p className="text-[#9298a8]">Logged in as:</p>
            <p className="font-medium">{user.email || 'admin@nascc.org'}</p>
          </div>
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 bg-[#A6410A] hover:bg-[#894d35] rounded-lg text-sm font-medium transition-colors"
          >
            Logout
          </button>
        </div>
      </nav>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
